export default {
  page: {
    title: 'Generador de texto',
    subtitle: 'Herramientas',
  },
  card: {
    title: 'Configuración de la generación',
  },
  form: {
    text: {
      label: 'Texto',
      placeholder: 'Ingrese el texto a generar',
    },
    selected: {
      label: 'Seleccionadas:',
    },
    enableSubWord: {
      label: 'Evitar palabra y subpalabra',
    },
  },
  button: {
    generate: 'Generar',
    clear: 'Limpiar',
    download: 'Descargar',
  },
  result: {
    list: {
      label: 'Lista:',
    },
    generatedText: {
      label: 'Texto generado:',
      placeholder: 'El texto generado aparecerá aquí',
    },
  },
  popover: {
    title: 'Palabras seleccionadas',
    description: 'seleccionadas',
  },
  alert: {
    repeatedWord: '¡Palabra repetida! {word}',
  },
  help: {
    title: 'Instrucciones',
    steps: [
      'Ingrese o pegue el texto.',
      'Seleccione una palabra.',
      'Presione Ctrl+B para marcarla.',
      'Haga clic en Generar.',
      'Descargue el resultado.',
    ],
  },
};
